import React, { useEffect } from 'react';
import _ from 'lodash';

const PatientCompassAd = ({
  patientCompassData,
  seoName,
  placementPage,
  cssClassName
}) => {
  const triggerDataLayerEvent = (
    eventName,
    linkText = null,
    linkUrl = null,
    contentfulId = null
  ) => {
    const objGTMParams = {
      event: eventName,
      seo_name: seoName,
      placement_name: placementPage,
      environment: process.env.REACT_APP_ENV
    };
    if (linkText) objGTMParams.click_text = linkText;
    if (linkUrl) objGTMParams.click_url = linkUrl;
    if (contentfulId) objGTMParams.contentfulId = contentfulId;
    _.triggerGTMVirtualPageViewEvent(objGTMParams);
    return true;
  };

  useEffect(() => {
    window.patientCompassGTMEvent = triggerDataLayerEvent;
    return () => {
      delete window.patientCompassGTMEvent;
    };
  }, []);

  return !_.isEmpty(patientCompassData?.patientCompassAdHtml) ? (
    <div
      className={`compassAds${
        !_.isEmpty(cssClassName) ? ' '.concat(cssClassName) : ''
      }`}
      dangerouslySetInnerHTML={{
        __html: patientCompassData?.patientCompassAdHtml
      }}
    ></div>
  ) : null;
};

export default PatientCompassAd;
